module.exports = __webpack_public_path__ + "static/media/ff_duplicates.46352b01.png";